<template>
  <section class="about-us diagonal-box reverse" id="rolunk">
    <div class="container">
      <div class="content items-center">
        <div class="title w-full" v-animate-in>
          <h2 class="h1 md:text-center margin">
            A Te szakértőd.<br />Az Offie csapata.
          </h2>
        </div>
        <div class="text md:text-justify" v-animate-in>
          <p>
            Az Offie egy dinamikus, családi vállalkozás, amelyet azért
            alapítottunk, hogy kihasználjuk a felismert piaci lehetőségeket. A
            kereskedelmi ingatlanokkal kapcsolatos szolgáltatásokra
            szakosodtunk, a bérlők képviseletére összpontosítva. Társalapítónk,
            Nagyházi Péter a budapesti irodapiac elismert szereplője, aki
            gyorsan megbízható partnerré tett minket ezen a területen.
          </p>
          <p>
            Munkánk iránti mély elkötelezettségünk kultúránk alapköve. Csapatunk
            tagjai széleskörű szakértelemmel és egyedi tapasztalatokkal
            rendelkeznek, ami lehetővé teszi, hogy átfogó, személyre szabott
            megoldásokat kínáljunk.
          </p>
          <p>
            Az irodakereséstől a bérleti tárgyalásokig minden vállalkozás
            számára igyekszünk megtalálni a tökéletes irodahelyiséget. Budapest
            nyüzsgő kereskedelmi központjában működünk, ahol szenvedélyünk, hogy
            ügyfeleink vállalkozását új magasságokba emeljük.
          </p>
        </div>
        <!-- <div class="image">
          <div class="circle-mask" v-animate-in>
            <ResponsiveImage
              :data="{
                sizes: [640, 1280, 1920],
                width: '1920',
                height: '1269',
                src: '/pictures/image-57.webp',
                alt: 'Offie - Forward Advisory',
              }"
            />
          </div>
          <div class="circle-mask right" v-animate-in>
            <ResponsiveImage
              :data="{
                sizes: [640, 1280, 1920],
                width: '1920',
                height: '1269',
                src: '/pictures/image-56.webp',
                alt: 'Offie - Forward Advisory',
              }"
            />
          </div>
          <div class="circle-mask" v-animate-in>
            <ResponsiveImage
              :data="{
                sizes: [640, 1280, 1920],
                width: '1920',
                height: '1269',
                src: '/pictures/image-55.webp',
                alt: 'Offie - Forward Advisory',
              }"
            />
          </div>
        </div> -->
        <div class="control w-full md:text-center" v-animate-in>
          <Button
            :to="{ path: '#kapcsolat' }"
            @click="next(this, event)"
            class="black"
            arrow="right"
            >Keress minket</Button
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";
// import ResponsiveImage from "@/components/ResponsiveImage.vue";

export default {
  name: "AboutUs",
  components: {
    Button
    // ResponsiveImage,
  }
};
</script>

<style lang="scss">
.about-us {
  display: block;
  width: 100%;
  //height: 100vh;
  // color: $white;
  padding: 90px 0 !important;
  background: $lightgray;

  .container {
    .content {
      .margin {
        margin: 0 15px;
      }
      display: flex;
      flex-direction: column;
      .title {
        order: 2;
        padding: 0 16px;
        margin-bottom: 8px;
      }
      .text {
        padding: 0 16px;
        order: 3;
      }
      .image {
        order: 1;
        padding: 0 32px 64px;
        picture {
          display: block;
          width: 100%;
          overflow: visible;
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        }
        .circle-mask {
          position: relative;
          display: block;
          width: 180px;
          height: 180px;
          &:before {
            box-shadow: 8px 8px 0 #324df7;
            position: absolute;
            border-radius: 50%;
            content: "";
            bottom: 0;
            right: 0;
            left: 0;
            top: 0;
            z-index: 1;
          }
          &.right {
            margin-left: 130px;
          }
          picture {
            position: relative;
            z-index: 2;
            display: block;
            img {
              display: block;
              border-radius: 50%;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .control {
        margin: 0 16px 24px;
        order: 4;
        padding-left: 30px;
        padding-left: 30px;
        a {
          width: initial !important;
        }
      }

      .button {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    margin: 0 0 50px;
    padding: 0 !important;
    .container {
      position: relative;
      .content {
        position: relative;
        z-index: 10;
        // margin-top: -240px;
        // padding-top: 240px;
        display: flex;
        height: 800px;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        .title {
          order: 1;
          width: 100%;
          box-sizing: border-box;
          // padding: 0 100px 0 0;
          margin-bottom: 16px;
        }
        .text {
          order: 2;
          // width: 58%;
          box-sizing: border-box;
          // padding: 0 100px 0 0;
          margin-bottom: 24px;
          padding: 0;
          p {
            margin: 0 0 16px 0;
          }
        }
        .control {
          order: 3;
          // width: 58%;
          box-sizing: border-box;
          padding: 0;
          margin: 0;
        }
        .button {
          width: auto;
        }
        .image {
          order: 4;
          width: 42%;
          margin: 80px 0 32px;
          .circle-mask {
            width: 240px;
            height: 240px;
            &.right {
              margin-left: 176px;
            }
          }
          .responsive-image {
            img {
              border-radius: 12px;
              height: 100%;
              max-height: 800px;
              width: auto;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
